// extracted by mini-css-extract-plugin
export default {"container":"Dp-z","brandName":"Ep-z","productName":"Fp-z","productNamePdpEnhancements":"Gp-z","breakLongProductName":"Hp-z"};